<template>
  <div class="m-view-tx">
    <h2>{{ $t("home.txTitle") }}</h2>
    <div class="tx-area table-shadow">
      <div class="tx-item" v-for="(item, index) in txList" :key="index">
        <div class="line flex-left">
          <p>
            {{ $t("home.txHash") }}：
            <router-link
              :to="{ name: 'tradeHash', params: { hash: item.hash } }"
              class="light hash txhash"
              >{{ item.hash | filterHash(8) }}</router-link
            >
          </p>
          <p class="grey">
            <count :time="item.block_time"></count>
          </p>
        </div>
        <div class="line flex-left">
          <p>
            {{ $t("home.sender") }}：
            <router-link
              :to="{ name: 'address', params: { address: item.from } }"
              class="light hash"
              >{{ item.from | filterHash(8) }}</router-link
            >
          </p>
          <p>
            {{ $t("home.receiver") }}：
            <router-link
              :to="{ name: 'address', params: { address: item.to } }"
              class="light hash"
              >{{ item.to | filterHash(8) }}</router-link
            >
          </p>
        </div>
        <div class="line flex-left">
          <p>
            <span class="grey tx-val">{{ $t("home.txValue") }}</span>
            {{ item | TradeValue }}
          </p>
        </div>
      </div>
      <router-link to="/tradelist" class="viewall-btn flex-center">{{
        $t("home.viewAll")
      }}</router-link>
    </div>
  </div>
</template>
<script>
import txBase from "@/mixins/Home/txList.js";
import Count from "@/components/Count.vue";
export default {
  mixins: [txBase],
  components: {
    Count,
  },
};
</script>

<style lang="scss" scoped>
.m-view-tx {
  h2 {
    margin: 30px 0 20px 12px;
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    font-weight: 500;
    color: $black;
    line-height: 20px;
  }
  .tx-area {
    background: $white;
    margin-bottom: 30px;
    .tx-item {
      min-height: 100px;
      padding: 15px 20px;
      border-bottom: 1px solid $border;
      color: $black;
      p:nth-of-type(1) {
        min-width: 50%;
      }
      p {
        line-height: 25px;
      }
      .tx-val {
        margin-right: 10px;
      }
      .txhash {
        margin-right: 10px;
      }
    }
    .grey {
      color: $grey;
    }
  }
  .viewall-btn {
    height: 60px;
    font-size: 14px;
    color: $orange;
  }
}
</style>
